import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Create_ledger_account } from "../ledger_accounts_root/Create_ledger_account";
import { Randomcode } from "../../components_root/rendom_code";
import { Ledger_accounts_manager } from "../ledger_accounts_root/ledger_accounts_manager";
import { ledger_books } from "../ledger_accounts_root/save_ledger_books";
export const Save_voucher = async (data) => {
  const { voucher, voucher_type,voucherid } = data || {};
 const servicetablename = "accountingfinancedb";
  if (!voucherid || !voucher.trim()) {
    return { success: false, error: "Missing voucherid." };
  }
  if (!voucher || !voucher.trim()) {
    return { success: false, error: "Missing voucher." };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken || sessiontoken === "undefined" || sessiontoken === "null") {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid || guid === "undefined" || guid === "null") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    // CHECK COMPANY EXISTS
    const servicetablename = "accountingfinancedb";
    const companyQuery = query(
      collection(db, servicetablename),
     where("companyuid", "==", select_company_uid)
    );
    const companySnap = await getDocs(companyQuery);

    if (companySnap.empty) {
      return { success: false, error: "Company does not exist." };
    }

    // SUBCOLLECTION
    const voucherCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "vouchers"
    );

    // CHECK DUPLICATE
    const duplicateQuery = query(
      voucherCollection,
      where("voucher_type", "==", voucher_type),
      where("voucher", "==", voucher)
    );

    const duplicateSnap = await getDocs(duplicateQuery);

    if (!duplicateSnap.empty) {
      return { success: false, error: "Voucher already exists." };
    }

    // GET LAST INDEXNUMBER
    const lastIndexQuery = query(
      voucherCollection,
      where("voucher_type", "==", voucher_type),
      orderBy("indexnumber", "desc"),
      limit(1)
    );
 const lastIndexSnap = await getDocs(lastIndexQuery);

    let indexnumber = 1;
    if (!lastIndexSnap.empty) {
      const lastDoc = lastIndexSnap.docs[0].data();
      indexnumber = (lastDoc.indexnumber || 0) + 1;
    }

    // CREATE NEW DOCUMENT INSIDE COMPANY → VOUCHERS
    //const uid = Randomcode(25);

    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      "vouchers",
      voucherid
    );
    const updateuid = Randomcode(15);
    const savequery = {
      ...data,
      indexnumber,
      voucherid,
      editable:false,
      updateuid,
      guid,
      companyuid: select_company_uid,
     
      logo_uid: "null",
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date()
    };

    await setDoc(parentDocRef, savequery); 
       
    return { success: true, message: "Voucher saved successfully." };

  } catch (err) {
    console.error("Error saving voucher:", err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};
